import { apiGet, apiPost, apiPut } from './client';

export function createArtifactUploadUrl(file) {
  return apiPost('/artifacts/upload-url', {
    filename: file.name,
    content_type: file.type || 'application/octet-stream',
    content_length: file.size,
  });
}

export async function uploadArtifactFile(uploadIntent, file) {
  const response = await fetch(uploadIntent.upload_url, {
    method: uploadIntent.method || 'PUT',
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
  if (!response.ok) {
    throw new Error(`Ошибка загрузки файла: ${response.status}`);
  }
}

export function submitArtifact(payload) {
  return apiPost('/artifacts', payload);
}

export function getArtifactSubmissions({ contextType, contextId }) {
  return apiGet(`/artifacts?context_type=${encodeURIComponent(contextType)}&context_id=${contextId}`);
}

export function getSchedule() {
  return apiGet('/me/schedule');
}

export function updateDigitalTrace(entryId, payload) {
  return apiPut(`/me/schedule/${entryId}/digital-trace`, payload);
}